import './style.scss'
const hasOwnPropertys = (data, ...keys) =>
  data !== null &&
  typeof data === 'object' &&
  keys.every(key => data.hasOwnProperty(key))

const convertValue = (value, data, fn) => {
  for (const item of data) {
    if (value === fn(item.value)) return item.value
  }
  return value
}
const matchValue = (value, options) => {
  if (Array.isArray(value)) return value.map(item => matchValue(item, options))
  switch (typeof value) {
    case 'string':
      return convertValue(value, options, String)
    case 'number':
      return convertValue(value, options, Number)
    default:
      break
  }
}
export default {

  name: 'BaseQuerySelect',

  props: {
    value: '',
    strict: Boolean,
    options: {
      type: Array,
      validator: value =>
        value.every(item => hasOwnPropertys(item, 'label', 'value')),
      default: () => []
    },
    loading: Boolean,
    loadingText: {
      type: String,
      default: '加载中...'
    },
    placeholder: String,
    setDefault: Function
  },

  computed: {
    query () {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (name !== 'BaseQuery') {
        parent = parent.$parent
        if (!parent) break
        name = parent.$options.name
      }
      return parent
    }
  },

  watch: {
    options: {
      handler (options) {
      
        if (options.length === 0) {
          this._options = []
          this.resetField()
          return
        }
        const value = this.strict ? this.value : matchValue(this.value, options)
        this._options = options
        const validValue = options.some(item => Array.isArray(value) ? value.some(val => val === item.value) : (item.value === value))
        if (validValue) return
        this.resetField()
      },
      deep: true,
      immediate: true
    },
    loading: 'resetField'
  },

  created () {
    this.initialValue = Array.isArray(this.value) ? [].concat(this.value) : this.value
  },

  mounted () {
    this.query && this.query.$emit('addField', this)
  },

  beforeDestroy () {
    this.query && this.query.$emit('removeField', this)
  },

  methods: {
    resetField () {
      const options = this._options || []
      let value = this.setDefault && options.length > 0 ? this.setDefault(options) : this.initialValue
      value = this.strict ? value : matchValue(value, options)
      if (value === this.value) return
      this.$emit('input', value)
      this.$emit('change', value)
    },
    async setOption (callback = () => []) {
      this._loading = true
      try {
        // eslint-disable-next-line standard/no-callback-literal
        const options = await callback(this)
        this._options = Array.isArray(options) ? options : []
      } catch (error) {
        console.error(error)
      }
      this._loading = false
    }
  },

  data () {
    return {
      _loading: false,
      _options: []
    }
  },

  render (h) {
    const { value, _options = [], strict, loadingText, placeholder } = this
    const on = this.$listeners
    const attr = this.$attrs
    let _value = strict ? value : matchValue(value, _options)
    const children = _options.map(({ label, value, disabled = false }) => (
      <el-option label={ label } value={ value } disabled={ disabled } />
    ))
    const loading = this._loading || this.loading
    return (<el-select
      value={ _value }
      placeholder={ loading ? loadingText : placeholder }
      loading={ loading }
      props={attr}
      { ...{ on } }
    >
      { loading ? <span slot="empty" class="query-select__loading"><i class="el-icon-loading" />{ loadingText }</span> : children }
    </el-select>)
  }
}
